module.exports = __webpack_public_path__ + "static/media/ic-info-outline-primary.9514c616.svg";